import React from "react";
import { useTranslation } from "react-i18next";
import UploadExperienceData from "./UploadExperienceData";
import NavbarIconsGenericComponent from "../generic-nav-bar/NavbarIconsGenericComponent";
import { debugLogPages } from "../../app/helpers/debugHelper";

const ImportDataExperienceScreen = () => {
  debugLogPages(':: ImportDataExperienceScreen');

  const { t } = useTranslation();

  return (
    <>
      <NavbarIconsGenericComponent componentName="ImportDataExperience" />

      <div className="d-flex justify-content-center page-title">{t("admin.importdata.experience.title")}</div>

      <hr className="line-hr" />

        <div>
        <UploadExperienceData />
        </div>
      
    </>
  );
};

export default ImportDataExperienceScreen;
